import { BLUE, BLUE_TEXT, GREEN, SUCCESS_TEXT, WARNING, WARNING_TEXT } from '../teacherStyles';

export type ClassTab = 'overview' | 'lesson' | 'student' | 'settings';

export const classTabs: ClassTab[] = ['overview', 'lesson', 'student', 'settings'];

export const classProfiles = {
    'intermediate-mandarin-ii': {
        name: 'Intermediate Mandarin II',
        schedule: 'Mon / Wed · 10:00–10:50 AM',
        room: 'Room 214',
        students: 18,
        progress: 72,
        lesson: 'Ordering Food at a Restaurant',
        lessonId: 'ordering-food-at-a-restaurant',
    },
    'mandarin-foundations': {
        name: 'Mandarin Foundations',
        schedule: 'Tue / Thu · 1:30–2:20 PM',
        room: 'Room 108',
        students: 24,
        progress: 46,
        lesson: 'Daily Routines and Time',
        lessonId: 'daily-routines-and-time',
    },
};

export const students = [
    { initials: 'AL', name: 'Ava Liu', email: 'ava.liu@example.edu', progress: 92, lastActive: 'Today, 9:14 AM', status: 'On track' },
    { initials: 'JM', name: 'Jonah Miller', email: 'jonah.m@example.edu', progress: 84, lastActive: 'Yesterday', status: 'On track' },
    { initials: 'SK', name: 'Sofia Kim', email: 'sofia.k@example.edu', progress: 78, lastActive: 'Yesterday', status: 'On track' },
    { initials: 'NP', name: 'Noah Patel', email: 'noah.p@example.edu', progress: 61, lastActive: '2 days ago', status: 'Needs practice' },
    { initials: 'EC', name: 'Emma Chen', email: 'emma.c@example.edu', progress: 54, lastActive: '3 days ago', status: 'Needs practice' },
    { initials: 'LR', name: 'Lucas Rivera', email: 'lucas.r@example.edu', progress: 28, lastActive: '6 days ago', status: 'Not started' },
];

export const lessons = [
    { id: 'restaurant-language-review', title: 'Restaurant Language Review', detail: '', status: 'Complete', completion: '18 of 18', color: GREEN, textColor: SUCCESS_TEXT, available: true },
    { id: 'ordering-food-at-a-restaurant', title: 'Ordering Food at a Restaurant', detail: 'Polite requests, measure words, and role-play', status: 'Current', completion: '14 of 18', color: BLUE, textColor: BLUE_TEXT, available: true },
    { id: 'paying-the-bill', title: 'Paying the Bill', detail: 'Prices, totals, and payment language', status: 'Draft', completion: 'Not available', color: WARNING, textColor: WARNING_TEXT, available: false },
];

export const exerciseInsights = [
    { label: 'Vocabulary review', result: '91% correct', note: 'Strongest activity', color: SUCCESS_TEXT },
    { label: 'Measure word practice', result: '68% correct', note: 'Most difficult', color: WARNING_TEXT },
    { label: 'Restaurant conversation', result: '76 speaking attempts', note: '3 need review', color: BLUE },
];
